import styled from 'styled-components';

export const StyledMessage = styled.p`
  margin-bottom: 1rem;
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`;
